export default {
  path: '/material_supplies',
  name: 'material_supplies',
  component: () => import('../components/materialsupply/Layout'),
  redirect: { name: 'MaterialSupplyList' },
  meta: {
    breadcrumb: 'profile.material.supplies',
  },
  children: [
    {
      name: 'MaterialSupplyList',
      path: '',
      component: () => import('../views/materialsupply/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'MaterialSupplyCreate',
      path: 'new',
      component: () => import('../views/materialsupply/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'MaterialSupplyUpdate',
      path: ':id/edit',
      component: () => import('../views/materialsupply/Update'),
      meta: {
        breadcrumb: 'profile.material.supply',
      },
    },
    {
      name: 'MaterialSupplyShow',
      path: ':id',
      component: () => import('../views/materialsupply/Show'),
      meta: {
        breadcrumb: 'profile.material.supply',
      },
    },
    {
      name: 'MaterialSupply',
      path: ':parent',
      component: () => import('../components/materialsupplysub/Layout'),
      meta: {
        breadcrumb: 'profile.material.supply',
      },
      children: [
        {
          name: 'MaterialSupplySubShow',
          path: ':id',
          component: () => import('../views/materialsupplysub/Show'),
          meta: {
            breadcrumb: 'profile.material.subsupply',
          },
        },
        {
          name: 'MaterialSupplySubUpdate',
          path: ':id/edit',
          component: () => import('../views/materialsupplysub/Update'),
          meta: {
            breadcrumb: 'profile.material.subsupply',
          },
        },
        {
          name: 'MaterialSupplySubCreate',
          path: 'new',
          component: () => import('../views/materialsupplysub/Create'),
          meta: {
            breadcrumb: 'global.add',
          },
        },
      ]

    },
    {
      name: 'MaterialSupplyFile',
      path: ':parent',
      component: () => import('../components/producttypefile/Layout'),
      meta: {
        breadcrumb: 'qualitycheck.product.producttypefiles',
      },
      children: [
        {
          name: 'ProducttypefileMaterialSupplyCreate',
          path: 'new',
          component: () => import('../views/producttypefile/Create'),
          meta: {
            breadcrumb: 'global.add',
          },
        },
      ]

    },
  ]
};
